import React from "react";
import styles from "./index.module.scss";

export default function Grid({ ...props }) {
  return <section className={styles.grid}>{props.children}</section>;
}
